import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link as MuiLink } from '@mui/material';
import { forwardRef } from 'react';
import { font } from '../../styles';
import { skipProps, styled } from '../../utils';
import { Icon } from '../Icon';
export const Link = forwardRef(function Link(props, ref) {
    const { children, variant, iconVariant, customIcon, iconFontSize, white, ...otherProps } = props;
    const isLink = !Array.isArray(props.children) && props.color !== 'inherit';
    return (_jsxs(LinkStyled, { variant: variant || 'body1', underline: "none", isLink: isLink, ref: ref, white: white, ...otherProps, children: [(customIcon !== undefined || iconVariant !== undefined) && (_jsx(IconStyled, { iconFontSize: iconFontSize, customIcon: customIcon, variant: 
                // Typescript can't infer that variant can't be undefined if customIcon is already undefined
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                customIcon ?? iconVariantFromLinkVariant(iconVariant) })), _jsx("span", { children: children })] }));
});
export const LinkStyled = styled(MuiLink, {
    shouldForwardProp: skipProps([
        'isLink',
        'iconVariant',
        'customIcon',
        'white',
    ]),
})(({ theme, isLink, white }) => ({
    ...(isLink && {
        display: 'inline-flex',
        alignItems: 'baseline',
        color: white ? theme.palette.common.white : theme.palette.primary.dark,
        '&:hover': {
            color: white
                ? theme.palette.primary.light
                : theme.palette.primary.lighter,
        },
    }),
}));
const iconSpacing = (iconFontSize) => {
    switch (iconFontSize) {
        case font.size.m:
            return 1;
        case font.size.l:
            return 1.5;
        case font.size.xl:
            return 2;
        default:
            return 1;
    }
};
export const IconStyled = styled(Icon, {
    shouldForwardProp: skipProps([
        'iconFontSize',
        'customIcon',
    ]),
})(({ theme, iconFontSize }) => ({
    alignSelf: 'center',
    fontSize: iconFontSize ?? font.size.m,
    marginRight: theme.spacing(iconSpacing(iconFontSize)),
}));
export function iconVariantFromLinkVariant(variant) {
    switch (variant) {
        case 'attachment':
            return 'arrow-download';
        case 'redirect':
            return 'arrow-right-2';
        default:
            return variant;
    }
    // Fallback safety
    throw new Error(`Icon variant can't be mapped to link variant: ${variant}`);
}
